(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header--int"]) return;
  try {
    
  class TransparentHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop === 0) {
        requestAnimationFrame(this.topPage.bind(this));
      } else {
        requestAnimationFrame(this.inPage.bind(this));
      }
    }

    inPage() {
      this.classList.add('header-in-page');
    }

    topPage() {
      this.classList.remove('header-in-page');
    }
  }

  customElements.define('transparent-header', TransparentHeader);

  } catch(e) { console.error(e); }
})();

})();
